/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import ShapeEnum from 'shared/enum/shape';

import SelectAlgorithm from 'shared/enum/select.algorithm';
import SelectStyle from 'shared/enum/select.style';
import SelectType from 'shared/enum/select.type';


export default class
{
  constructor (args)
  {
    this.args = args;
  }


  canNavigate ()
  {
    return true;
  }


  canSelect ()
  {
    return false;
  }


  getSelectAlgorithm ()
  {
    return SelectAlgorithm.Shape
  }


  getSelectStyle ()
  {
    return SelectStyle.Default;
  }


  // TODO default navigation should be OK for all 3 types (excluding galaxy).
  // But most other behaviors - firing, flows, would probably only want Zone or maybe Platform, right?
  getSelectType ()
  {
    return SelectType.Zone | SelectType.Platform | SelectType.Dock;
  }


  getSelectValueCount (current, target, galaxy)
  {
    return 1;
  }


  getSelectRange ()
  {
    return 0;
  }


  getSelectShape (current, galaxy)
  {
    return ShapeEnum.Single;
  }


  getSelectInitialTargets (current, galaxy)
  {
    return { };
  }


  isPaneCollapsed ()
  {
    return true;
  }


};
